<template>
  <div>
    <div class="touch" v-show="showContactEnquiry">
      <div class="title">
        {{ $t("touch") }}&nbsp;&nbsp;&nbsp;&nbsp;{{ $t("touch1") }}
      </div>
      <div class="box" @click="modal11 = true">{{ $t("enquiry") }}</div>
      <!-- web咨询模态框 -->
      <Modal
        v-model="modal11"
        footer-hide
        width="80"
        class="web-enquiry"
        @on-visible-change="clear"
      >
        <Row>
          <Col span="24" class="modal-title">{{ $t("enquiryBox.title") }}</Col>
        </Row>
        <Row>
          <Col span="24" class="modal-des">{{ $t("enquiryBox.des") }}</Col>
        </Row>
        <Row>
          <Col class="modal-line"></Col>
        </Row>
        <Row style="margin-top: 0.55rem; margin-bottom: 0.2rem">
          <Col span="12" class="left-box">
            <div class="nav-help">
              <p class="help-title">{{ $t("enquiryBox.left.title1") }}</p>
              <div class="help-content">
                <img src="../assets/web/对号.svg" />
                {{ $t("enquiryBox.left.text1") }}
              </div>
              <div class="help-content">
                <img src="../assets/web/对号.svg" />
                {{ $t("enquiryBox.left.text2") }}
              </div>
              <div class="help-content">
                <img src="../assets/web/对号.svg" />
                {{ $t("enquiryBox.left.text3") }}
              </div>
              <div class="help-content">
                <img src="../assets/web/对号.svg" />
                {{ $t("enquiryBox.left.text4") }}
              </div>
            </div>
            <div class="nav-email">
              <p class="help-title">{{ $t("enquiryBox.left.title2") }}</p>
              <p class="email-des help-content">
                {{ $t("enquiryBox.left.text5") }}
              </p>
              <a href="mailto:support@redteamobile.net" class="email-name">
                {{ $t("enquiryBox.left.text6") }}
              </a>
              <p class="email-des help-content">
                {{ $t("enquiryBox.left.text7") }}
              </p>
              <a
                href="mailto:communications@redteamobile.com"
                class="email-name"
                >{{ $t("enquiryBox.left.text8") }}</a
              >
            </div>
            <div class="nav-find">
              <p class="help-title">{{ $t("enquiryBox.left.title3") }}:</p>
              <Poptip trigger="hover" placement="top">
                <img
                  src="../assets/web/微信.svg"
                  style="margin-left: -0.1rem; width: 0.68rem"
                />
                <div slot="content">
                  <img
                    src="../assets/web/红茶移动微信二维码.jpg"
                    style="width: 150px"
                  />
                </div>
              </Poptip>
              <a href="https://www.facebook.com/redteamobile" target="_Blank">
                <img
                  src="../assets/web/Facebook.svg"
                  style="margin-left: -0.08rem"
                />
              </a>
              <a href="https://twitter.com/redteamobile" target="_Blank">
                <img src="../assets/web/Twitter.svg" />
              </a>
              <a
                href="https://www.linkedin.com/company/13216053/"
                target="_Blank"
              >
                <img src="../assets/web/Linkedin.svg" />
              </a>
              <a
                href="https://www.zhihu.com/org/redteamobile/activities"
                target="_Blank"
              >
                <img src="../assets/web/知乎.svg" />
              </a>
            </div>
          </Col>
          <Col span="12" class="right-box">
            <Form
              ref="formEnquiry"
              :model="formEnquiry"
              :rules="ruleValidate"
              :show-message="false"
            >
              <FormItem>
                <Input
                  v-model="formEnquiry.name"
                  :placeholder="$t('enquiryBox.right.text1')"
                  style="width: 75%"
                />
              </FormItem>
              <FormItem prop="businessEmail">
                <Input
                  v-model="formEnquiry.businessEmail"
                  :placeholder="$t('enquiryBox.right.text2')"
                  style="width: 75%"
                />
              </FormItem>
              <FormItem>
                <Input
                  v-model="formEnquiry.company"
                  :placeholder="$t('enquiryBox.right.text3')"
                  style="width: 75%"
                />
              </FormItem>
              <FormItem>
                <Input
                  v-model="formEnquiry.phoneNumber"
                  :placeholder="$t('enquiryBox.right.text4')"
                  style="width: 75%"
                />
              </FormItem>
              <FormItem>
                <Input
                  v-model="formEnquiry.help"
                  :placeholder="$t('enquiryBox.right.text5')"
                  style="width: 75%"
                />
              </FormItem>
            </Form>
            <div class="confirm-btn" @click="send">
              {{ $t("enquiryBox.hear") }}
            </div>
          </Col>
        </Row>
      </Modal>
    </div>
    <div>
      <div class="nav-footer-web">
        <Row type="flex" justify="space-between">
          <Col class="logo-box" :span="3" style="text-align: center">
            <img src="../assets/底端导航/redtea_logo_en.png" />
            <!-- <img src="../assets/底端导航/红茶移动logo (1).png" /> -->
          </Col>
          <Col class="float-box" :span="3">
            <router-link to="/RedteaGo#header">
              <p class="footer-title">{{ $t("nav.Consumers") }}</p>
            </router-link>
            <ul class="footer-list">
              <router-link to="/RedteaGo#iosEsim">
                <li>{{ $t("nav.iosEsim") }}</li>
              </router-link>
              <router-link to="/RedteaGo#Android">
                <li v-html="$t('nav.AndroidWeb')"></li>
              </router-link>
              <!--              <router-link to="/RedteaGo#iPhone">-->
              <!--                <li>{{ $t('nav.iPhone') }}</li>-->
              <!--              </router-link>-->
              <!--              <a href="https://esim.redteago.com/">-->
              <!--                <li>{{ $t("nav.eSIMDataPlan") }}</li>-->
              <!--              </a>-->
              <!--              <router-link to="/RedteaGo#SIMCard">-->
              <!--                <li v-html="$t('nav.GlobalSIMWeb')"></li>-->
              <!--              </router-link>-->
            </ul>
          </Col>
          <Col class="float-box" :span="3.5">
            <router-link to="/RedteaReady#header">
              <p class="footer-title">{{ $t("nav.M2M") }}</p>
            </router-link>
            <ul class="footer-list">
              <router-link to="/RedteaReady#FWA">
                <li>{{ $t("nav.Fixed") }}</li>
              </router-link>
              <router-link to="/RedteaReady#Automotive">
                <li>{{ $t("nav.Automotive") }}</li>
              </router-link>
              <router-link to="/RedteaReady#Handheld">
                <li>{{ $t("nav.Handheld") }}</li>
              </router-link>
              <router-link to="/RedteaReady#Logistics">
                <li>{{ $t("nav.Logistcs") }}</li>
              </router-link>
              <router-link to="/RedteaReady#Utilities">
                <li>{{ $t("nav.Utilities") }}</li>
              </router-link>
              <router-link to="/RedteaReady#Wearable">
                <li>{{ $t("nav.Dongle") }}</li>
              </router-link>
            </ul>
          </Col>
          <Col class="float-box" :span="3">
            <router-link to="/RedteaSIM#header">
              <p class="footer-title">{{ $t("nav.eSIMDes") }}</p>
            </router-link>
            <ul class="footer-list">
              <router-link to="/RedteaSIM#cost">
                <li>{{ $t("nav.cost") }}</li>
              </router-link>
              <router-link to="/RedteaSIM#Improve">
                <li>{{ $t("nav.Improve") }}</li>
              </router-link>
              <router-link to="/RedteaSIM#exp">
                <li>{{ $t("nav.exp") }}</li>
              </router-link>
            </ul>
          </Col>
          <Col class="float-box" :span="3">
            <router-link to="/esim-plus">
              <p class="footer-title">{{ $t("nav.eSimPlus") }}</p>
            </router-link>
          </Col>
          <Col class="float-box" :span="2">
            <router-link to="/CaaS#header">
              <p class="footer-title">{{ $t("nav.CaaS") }}</p>
            </router-link>
            <ul class="footer-list">
              <router-link to="/CaaS#Global">
                <li>{{ $t("nav.Global") }}</li>
              </router-link>
              <router-link to="/CaaS#Embedded">
                <li>{{ $t("nav.Embedded") }}</li>
              </router-link>
              <router-link to="/CaaS#Open">
                <li>{{ $t("nav.Open") }}</li>
              </router-link>
              <router-link to="/CaaS#Smart">
                <li>{{ $t("nav.Smart") }}</li>
              </router-link>
            </ul>
          </Col>
          <Col class="float-box" :span="3">
            <router-link to="/Resources#News">
              <p class="footer-title">{{ $t("nav.Resources") }}</p>
            </router-link>
            <ul class="footer-list">
              <router-link to="/Resources#News">
                <li>{{ $t("nav.NewsEvents") }}</li>
              </router-link>
              <router-link to="/Resources#Industry">
                <li>{{ $t("nav.IndustryReports") }}</li>
              </router-link>
              <router-link to="/Resources#Insights">
                <li>{{ $t("nav.Insights") }}</li>
              </router-link>
              <router-link to="/Resources#Terms">
                <li>{{ $t("nav.TermsJargons") }}</li>
              </router-link>
              <router-link to="/Resources#FAQ">
                <li>{{ $t("nav.FAQ") }}</li>
              </router-link>
            </ul>
          </Col>
          <Col class="float-box" :span="2">
            <router-link to="/about#Overview">
              <p class="footer-title">{{ $t("nav.AboutUs") }}</p>
            </router-link>
            <ul class="footer-list">
              <router-link to="/about#Overview">
                <li>{{ $t("nav.Overview") }}</li>
              </router-link>
              <router-link to="/about#Mission">
                <li>{{ $t("nav.Mission") }}</li>
              </router-link>
              <router-link to="/about#Vision">
                <li>{{ $t("nav.Vision") }}</li>
              </router-link>
              <router-link to="/about#Values">
                <li>{{ $t("nav.Values") }}</li>
              </router-link>
              <router-link to="/about#Recognition">
                <li>{{ $t("nav.Recognition") }}</li>
              </router-link>
              <router-link to="/about#Careers">
                <li>{{ $t("nav.Careers") }}</li>
              </router-link>
              <router-link to="/about#Team">
                <li>{{ $t("nav.Team") }}</li>
              </router-link>
            </ul>
          </Col>
        </Row>
        <Row>
          <Col :span="8" class="footer-follow">
            <div class="follow-title">{{ $t("follow") }}:</div>
            <div>
              <Poptip trigger="hover" placement="top">
                <img
                  src="../assets/底端导航/微信.svg"
                  style="margin-left: -0.1rem; width: 0.58rem"
                />
                <div slot="content">
                  <img
                    src="../assets/web/红茶移动微信二维码.jpg"
                    style="width: 150px"
                  />
                </div>
              </Poptip>
              <a href="https://www.facebook.com/redteamobile" target="_Blank">
                <img
                  src="../assets/底端导航/Facebook.svg"
                  style="margin-left: -0.08rem"
                />
              </a>
              <a href="https://twitter.com/redteamobile" target="_Blank">
                <img src="../assets/底端导航/Twitter.svg" />
              </a>
              <a
                href="https://www.linkedin.com/company/13216053/"
                target="_Blank"
              >
                <img src="../assets/底端导航/Linkedin.svg" />
              </a>
              <a
                href="https://www.zhihu.com/org/redteamobile/activities"
                target="_Blank"
              >
                <img src="../assets/底端导航/知乎.svg" />
              </a>
            </div>
          </Col>
          <Col :span="16" class="policy"
            >{{ $t("nav.copyRight")
            }}<a
              class="icp-link"
              href="http://beian.miit.gov.cn"
              target="_blank"
              >粤ICP备20020278号</a
            ></Col
          >
        </Row>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "nav-footer-web",
  data() {
    return {
      showContactEnquiry: false,
      value: "",
      modal11: false,
      formEnquiry: {
        name: "",
        businessEmail: "",
        company: "",
        phoneNumber: "",
        help: "",
      },
      ruleValidate: {
        businessEmail: [
          {
            required: true,
            message: this.$t("mail1"),
            trigger: "blur",
          },
          {
            pattern:
              /^([A-Za-z0-9_\-\.\u4e00-\u9fa5])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,8})$/,
            message: this.$t("mail2"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    clear(flag) {
      if (!flag) {
        this.formEnquiry.name = "";
        this.formEnquiry.businessEmail = "";
        this.formEnquiry.company = "";
        this.formEnquiry.phoneNumber = "";
        this.formEnquiry.help = "";
      }
    },
    send() {
      let param = this.formEnquiry;
      this.$refs.formEnquiry.validate((valid) => {
        if (valid) {
          this.$Message.success(this.$t("success"));
          this.$api.api.enquiry({ ...param, site: 1 }).then((res) => {
            this.modal11 = false;
          });
        } else {
          if (this.formEnquiry.businessEmail) {
            this.$Message.error(this.$t("mail2"));
          } else {
            this.$Message.error(this.$t("mail1"));
          }
        }
      });
    },
  },
  mounted() {
    setTimeout(() => {
      if (this.$route.path !== "/esim-plus") {
        this.showContactEnquiry = true;
      } else {
        this.showContactEnquiry = false;
      }
    }, 1000);
  },
};
</script>
<style lang="less" scoped>
.touch {
  display: flex;
  background: rgba(249, 249, 249, 1);
  justify-content: center;
  padding: 0.8rem 0;
  .title {
    font-family: "Poppins-Regular";
    font-size: 20px;
    line-height: 0.6rem;
    margin-right: 1rem;
  }
  .box {
    width: 3rem;
    height: 0.6rem;
    line-height: 0.6rem;
    font-family: "Poppins-Regular";
    font-size: 20px;
    background: rgba(207, 42, 42, 1);
    border-radius: 4px;
    color: rgba(255, 255, 255, 1);
    cursor: pointer;
  }
}
.nav-footer-web {
  padding-top: 0.6rem;
  width: 100%;
  padding-left: 0.32rem;
  padding-right: 0.32rem;
  background-color: #182456;
  color: rgba(255, 255, 255, 1);
  .logo-box {
    text-align: left;
    img {
      width: 1.3rem;
    }
  }
  .circle-icon {
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background-color: #fff;
    display: inline-block;
    margin: 0 0.1rem 0 0.2rem;
  }
  .footer-title {
    color: rgba(255, 255, 255, 1);
    font-family: "Poppins-Regular";
    font-size: 14px;
    letter-spacing: 1px;
    text-align: left;
    margin-bottom: 0.2rem;
    margin-left: 15px;
  }
  .footer-title:before {
    background-image: url("../assets/底端导航/标题.svg");
    content: "";
    background-size: 10px 10px;
    position: absolute;
    width: 10px;
    height: 10px;
    left: -5px;
    top: 4px;
  }
  .footer-list {
    font-family: "Poppins-Light";
    font-size: 12px;
    letter-spacing: 1px;
    text-align: left;
    margin-bottom: 0.12rem;
    margin-left: 30px;
    li {
      color: rgba(255, 255, 255, 0.7);
      margin-bottom: 10px;
      transition: color 0.25s;
      &:hover {
        color: #ffffff;
      }
    }
  }
  .footer-follow {
    text-align: left;
    margin-bottom: 0.1rem;
    .follow-title {
      font-size: 14px;
      margin-bottom: 0.2rem;
    }
    img {
      width: 0.48rem;
    }
  }
  .policy {
    text-align: left;
    font-size: 14px;
    letter-spacing: 1px;
    font-family: PingFangSC;
    margin-top: 0.6rem;
    .icp-link {
      margin-left: 20px;
      color: #fff;
    }
  }
}
@media screen and (max-width: 1200px) {
  .nav-footer-web {
    width: 100%;
  }
}
</style>